(function () {
	'use strict';
	angular.module('smb-app')
		.directive('smbadminUserGroups', [UserGroupsDirective])
		.controller('smbadminUserGroupsController',
		[
			'$state',
			'smbToolbarService',
			'smbUserGroupsDataStore',
			'pxProgressService',
			'gettextCatalog',
			UserGroupsController
		]);

	var templateUrl = require('./userGroups.template');
	function UserGroupsDirective() {
		return {
			restrict: 'E',
			controller: UserGroupsController,
			controllerAs: 'vm',
			templateUrl: templateUrl,
			bindToController: true,
			scope: {}
		};
	}
	function UserGroupsController($state, smbToolbarService, smbUserGroupsDataStore, pxProgressService, gettextCatalog) {
		smbToolbarService.set(gettextCatalog.getString('User Groups Configuration'), 'useradmin.home');

		var vm = this;
		vm.loading = false;
		vm.userGroupDS = smbUserGroupsDataStore;
		vm.addUserGroup = addUserGroup;
		vm.editUserGroup = editUserGroup;

		(function loadUserGroups() {
			isLoading();
			smbUserGroupsDataStore.getUserGroups().finally(doneLoading);
		})();

		function editUserGroup(group) {
			$state.go('useradmin.home.usergroups.details', { usergroupId: group.UserGroupId });
		}

		function addUserGroup() {
			$state.go('useradmin.home.usergroups.details');
		}

		function isLoading() {
			vm.loading = true;
			pxProgressService.visible = true;
		}

		function doneLoading() {
			vm.loading = false;
			pxProgressService.visible = false;
		}
	}

}());


//////////////////
// WEBPACK FOOTER
// ./app/components/userGroups/userGroups.js
// module id = 103
// module chunks = 1